import styled, { css } from 'styled-components';
import { FlexBoxRow, FlexBoxCol } from '@r1-frontend/ui-react/components/layouts/flexBoxGrid';
import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import { fonts } from '~/src/helpers/font';
import { breakPoints, styleWithBreakPoints } from '~/src/components/LandingBlock/styled';
import { IMG_DOMAIN } from '~/src/services/blocks/templates';

const getFontColor = (customStyles) => {
    if (customStyles['Header.CitySelect']) {
        const customColor = customStyles['Header.CitySelect'].desktop
            .filter(style => style.includes('color:'))[0]
            .split(':')[1]
            .trim()
            .slice(0, -1);
        return css`background-color: ${customColor ? customColor : COLORS.black}`;
    }
    return css`background-color: ${COLORS.black}`;
};

export const HeaderPanel = styled.div`
    width: 100%;
    padding: 10px 0;
    background-color: transparent;
    order: -1;
    position: relative;
`;

export const Row = styled(FlexBoxRow)<{ wrap: string }>`
    width: 100%;
    flex-wrap: ${p => p.wrap ?? 'wrap'};
`;

export const Col = styled(FlexBoxCol)`
    display: flex;
    align-items: right;
    z-index: 2;
`;

export const GrowCol = styled(Col)`
    flex: 1 0 auto !important;

    @media (max-width: ${breakPoints.mobile}) {
        max-width: 230px;
    }
`;

export const Logo = styled.img`
    width: 173px;
    height: 78px;
    position:relative;
    z-index: 10;

    @media (max-width: ${breakPoints.mobile}) {
        width: 64px;
        height: 64px;
    }
`;

export const CurrentCity = styled.span`
    position:relative;
    display: flex;
    align-items: center;
    margin-left: 8px;
    padding-left: 25px;
    min-height: 15px;
    cursor: pointer;
    z-index: 10;

    color: ${COLORS.black};

    &:before {
        content: '';
        position:absolute;
        left: 0;
        top: 2px;
        width: 14px;
        height: 14px;
        mask: url(${require('~/public/icons/location.svg')}) no-repeat left center;
        ${p => getFontColor(p)}
    }

    @media (max-width: ${breakPoints.mobile}) {
        display: block;
        margin-top: 12px;
        margin-left: 0;
    }

    &:hover {
        color: ${COLORS.red};

        &:before {
            background-color: ${COLORS.red};
        }
    }

    ${p => styleWithBreakPoints(p, 'Header.CitySelect')};
`;

export const PhoneCol = styled(Col)`
    justify-content: flex-end;
    @media (max-width: ${breakPoints.mobile}) {
        justify-content: flex-start;
    }
`;

export const Phone = styled.a`
    display: block;
    text-align: right;
    cursor: pointer;
    margin-right: 40px;

    &:hover {
        color: ${COLORS.red};
        text-decoration: none;
    }

    @media (max-width: ${breakPoints.mobile}) {
        text-align: left;
        font: ${fonts.XS};
    }

    ${p => styleWithBreakPoints(p, 'Header.Phone')}
`;

export const Age = styled.div<{ backgroundColor: string, image: string}>`
    position: absolute;
    right: 0;
    top: 35px;
    width: 30px;
    height: 30px;
    -webkit-mask-image: url(${IMG_DOMAIN}${p => p.image});
    mask-image: url(${IMG_DOMAIN}${p => p.image});
    mask-size: contain;
    -webkit-mask-size: contain;
    mask-repeat: no-repeat;
    -webkit-mask-repeat: no-repeat;
    background-color: ${p => p.backgroundColor};
`;
